import axios from "axios";
import { getKey } from "../utils/localStorage";
import { baseAPI } from "../utils/constants";

export const getRequest = <T>({ url, headers = {} }) => {
  return axios.get<T>(`${baseAPI}/${url}`, {
    headers: {
      Authorization: `Bearer ${getKey("token")}`,
      ...headers,
    },
  });
};

export const getRequestParams = <T>({ url, headers = {}, params = {}}) => {
  return axios.get<T>(`${baseAPI}/${url}`, {
    headers: {
      Authorization: `Bearer ${getKey("token")}`,
      ...headers,
    },
    params: {
      ...params
    }
  });
};

export const deleteRequest = <T>({ url, headers = {} }) => {
  return axios.delete<T>(`${baseAPI}/${url}`, {
    headers: {
      Authorization: `Bearer ${getKey("token")}`,
      ...headers,
    },
  });
};


export const postRequest = <T>({ url, body = {}, headers = {} }) => {
  return axios.post<T>(`${baseAPI}/${url}`, body, {
    headers: {
      Authorization: `Bearer ${getKey("token")}`,
      ...headers,
    },
  });
};

export const patchRequest = <T>({ url, body = {}, headers = {} }) => {
  return axios.patch<T>(`${baseAPI}/${url}`, body, {
    headers: {
      Authorization: `Bearer ${getKey("token")}`,
      ...headers,
    },
  });
};

export const checkToken = (token?) => {
  return axios.get(`${baseAPI}/checkToken`, {
    headers: {
      Authorization: `Bearer ${token || getKey("token")}`,
    },
  });
};
